<template>
  <HelloWorld msg="Pinyin by Issac"/>
</template>

<script>
import './assets/tailwind.css';
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>

</style>
